module.exports = __webpack_public_path__ + "img/towing_devices.3a0c1620.svg";